import { BrowserRouter as Router } from "react-router-dom";
import Routers from "src/modules/common/components/Routers";

function App(props) {
  return (
    <Router>
      <Routers />
    </Router>
  );
}

export default App;
